import { IcoSearch } from "assets/icons";
import { Input } from "components";
import React, { useEffect, useState } from "react";
import "./styles.scss";

export type SearchBarProps = {
	label: string;
	placeholder: string;
	onSearch: (value: string) => void;
};

const ONE_SECOND = 1000;

export default function SearchBar({
	label,
	placeholder,
	onSearch
}: Readonly<SearchBarProps>) {
	const [searchText, setSearchText] = useState<string>("");

	useEffect(() => {
		const delaySearch = setTimeout(() => {
			onSearch(searchText);
		}, ONE_SECOND);

		return () => clearTimeout(delaySearch);
	}, [searchText, onSearch]);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchText(event.target.value);
	};

	return (
		<div className="search-bar">
			<Input
				label={label}
				placeholder={placeholder}
				type="text"
				name="searchText"
				value={searchText}
				onChange={handleChange}
				Icon={<IcoSearch />}
				hideOptional
			/>
		</div>
	);
}
